import {Col, Row} from "react-bootstrap";
import {trans} from "../../../../../../translations/translations";

const HungerAdvice2 = () => {
    return (
        <Row className={"response-row"}>
            <Col xs={12} className={"title mb-2"}>
                <p className={"m-0"}>
                    <span className={"me-1"}>{trans('results.answer1.hunger.advice2.title.text1', 'sos')}</span>
                    <span className={"me-1 text-pink text-bold"}>{trans('results.answer1.hunger.advice2.title.text2', 'sos')}</span>
                    <span className={"me-1 "}>{trans('results.answer1.hunger.advice2.title.text3', 'sos')}?</span>
                </p>
            </Col>
            <Col xs={12} className={"text-result mb-3"}>
                <p className={"m-0"}>{trans('results.answer1.hunger.advice2.sub.text1', 'sos')}</p>
            </Col>
            <Col xs={12} className={"text-result"}>
                <p className={"m-0"}>{trans('results.answer1.hunger.advice2.sub.text2', 'sos')}</p>
            </Col>
            <Col xs={12} className={"text-result mb-2"}>
                <ul>
                    <li>{trans('results.answer1.hunger.advice2.sub.text3', 'sos')}</li>
                    <li>{trans('results.answer1.hunger.advice2.sub.text4', 'sos')}</li>
                    <li>{trans('results.answer1.hunger.advice2.sub.text5', 'sos')}</li>
                    <li>{trans('results.answer1.hunger.advice2.sub.text6', 'sos')}</li>
                    <li>{trans('results.answer1.hunger.advice2.sub.text7', 'sos')}</li>
                </ul>
            </Col>
            <Col xs={12} className={"text-result"}>
                <p className={"m-0"}>{trans('results.answer1.hunger.advice2.sub.text8', 'sos')}</p>
            </Col>
        </Row>
    )
}

export default HungerAdvice2;
